import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68e8815c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","min-width":"90%"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder","fontSize":"14px"} })
  ])
], -1))
const _hoisted_2 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_component_q_linear_progress, {
        indeterminate: "",
        color: "warning",
        class: "q-mt-sm"
      }, null, 512), [
        [_vShow, _ctx.loadingData]
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeAccounts, (timeAccount, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "text-subtitle2 card_balanta",
            key: index
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("b", null, "Balanta " + _toDisplayString(timeAccount.timeName) + " " + _toDisplayString(timeAccount.year), 1)
            ]),
            _createElementVNode("div", null, "Drept: " + _toDisplayString(timeAccount.nrDaysPerYear) + ", Planificat: " + _toDisplayString(timeAccount.nrDaysPlanned) + ", Aprobat: " + _toDisplayString(timeAccount.nrDaysApproved) + ", Consumat: " + _toDisplayString(timeAccount.nrDaysConsumed) + ", Rest zile: " + _toDisplayString(timeAccount.nrDaysAvailable), 1)
          ]))
        }), 128))
      ]),
      (!_ctx.loadingData && _ctx.timeAccounts.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nu exista balante de timp definite pentru aceasta persoana!"))
        : _createCommentVNode("", true)
    ])
  ]))
}